import React from "react";
import styled from "styled-components";
import palette from "../../lib/styles/palette";

const TitleInput = styled.input`
  font-size: 3rem;
  outline: none;
  border: none;
  padding-bottom: 0.5rem;
  padding-left: 10px;
  margin-bottom: 2rem;
  border-bottom: 1px solid ${palette.gray[4]};
  width: 100%;
  box-sizing: border-box;
  // background: red;
`;

const TitleBox = ({ value, setPost }) => {
  const onChange = e => {
    setPost(prev => ({...prev, title:e.target.value}));
  };

  return (
    <div className="TitleBox">
      <TitleInput
        name="title"
        value={value}
        onChange={onChange}
        placeholder="제목을 입력하세요"
      />
    </div>
  );
};

export default TitleBox;
